export enum ContactFilterStatus {
    Active = 'active',
    IsRegisterOnPortal = 'isRegisterOnPortal'
}
